import { render } from "./UnitBreakdown.vue?vue&type=template&id=317b2afc&scoped=true"
import script from "./UnitBreakdown.vue?vue&type=script&lang=js"
export * from "./UnitBreakdown.vue?vue&type=script&lang=js"

import "./UnitBreakdown.vue?vue&type=style&index=0&id=317b2afc&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\860\\s\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317b2afc"]])

export default __exports__